<template>
  <div class="committee-secretary-picker">
    <span class="text-muted">Pick the contact from the committee </span>
    <a href="#" class="text-primary" @click.prevent="open">secretaries</a>

    <modal v-if="showModal" @close="showModal = false">
      <h2 slot="header" class="h4 mb-0">Committee Secretaries</h2>
      <div slot="body" class="w-100">
        <div v-if="loading" class="text-center p-3">
          <div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>
        </div>
        <div v-else-if="error" class="alert alert-warning mb-0">{{ error }}</div>
        <p v-else-if="secretaries.length === 0" class="text-center text-muted mb-0">No secretaries found.</p>
        <div v-else class="list-group">
          <button
            v-for="secretary in secretaries"
            :key="secretary.id"
            type="button"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            @click="select(secretary)"
          >
            <span>{{ secretary.name }}</span>
            <span class="text-muted">{{ secretary.phone }}</span>
          </button>
        </div>
      </div>
      <div slot="footer" class="d-flex justify-content-center">
        <button type="button" class="btn btn-outline-primary" @click="showModal = false">Cancel</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import committeesApi from '@/services/api/committees'

// Draft Setup helper: the secretary contact is not always the person filling the form, so a
// secretary of the committee (own, or the one a Super Secretary is acting for) can be picked
// from a popup. Emits `select` with { name, phone }.
export default {
  name: 'CommitteeSecretaryPicker',
  components: { Modal },
  data() {
    return {
      showModal: false,
      loading: false,
      error: '',
      secretaries: []
    }
  },
  methods: {
    open() {
      this.showModal = true
      this.loading = true
      this.error = ''
      committeesApi.getSecretaries().then((response) => {
        this.secretaries = response.data.data
      }).catch(() => {
        this.error = 'Unable to load secretaries. Please try again.'
      }).finally(() => { this.loading = false })
    },
    select(secretary) {
      this.$emit('select', { name: secretary.name, phone: secretary.phone || '' })
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Drafts/CommitteeSecretaryPicker.vue